module.exports = __webpack_public_path__ + "img/DE02700.da68308f.png";